var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 192,
    viewBox: "0 0 290 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290 186.898C290 189.719 287.724 192 284.919 192H5.08148C2.27466 192 0 189.719 0 186.898V186.547C0 183.73 2.27466 181.444 5.08148 181.444H284.919C287.724 181.444 290 183.73 290 186.547V186.898Z",
    fill: "#F1ECE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.473 50.0273V22.8797C129.473 11.3501 138.781 1.99956 150.262 1.99956C161.745 1.99956 171.052 11.3501 171.052 22.8797V50.0273",
    stroke: "#B31D2D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.633 46.3322V162.443H197.896V46.3322H102.633Z",
    fill: "#EF4742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150 46.3322V162.443H197.895V46.3322H150Z",
    fill: "#EF4742"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4727 57.4175V181.445H201.052V57.4175H99.4727Z",
    fill: "#F4695B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150 57.4175V181.445H201.053V57.4175H150Z",
    fill: "#F2574F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.053 57.416L182.105 51.0827V57.416H201.053Z",
    fill: "#F4695B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.105 51.2104L197.895 46.3335V56.3613L182.105 51.2104Z",
    fill: "#F2574F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4727 57.416L118.42 51.0827V57.416H99.4727Z",
    fill: "#F2574F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.422 51.2104L102.633 46.3335V56.3613L118.422 51.2104Z",
    fill: "#F4695B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.052 67.4449V94.5902C171.052 106.119 161.745 115.473 150.262 115.473C138.778 115.473 129.473 106.119 129.473 94.5902V67.4449",
    stroke: "#B31D2D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.633 86.4449V172.473H252.633V86.4449H182.633Z",
    fill: "#E69123"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.367 86.4449V172.473H252.63V86.4449H217.367Z",
    fill: "#E69123"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180 94.3615V186.723H255.263V94.3615H180Z",
    fill: "#EAB957"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.367 94.3615V186.723H255.262V94.3615H217.367Z",
    fill: "#EDA738"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M255.261 94.3613L241.051 90.1391V94.3613H255.261Z",
    fill: "#EAB957"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.051 90.0396L252.63 86.4451V93.834L241.051 90.0396Z",
    fill: "#EDA738"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180 94.3613L194.211 90.1391V94.3613H180Z",
    fill: "#EDA738"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.212 90.0396L182.633 86.4451V93.834L194.212 90.0396Z",
    fill: "#EAB957"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.632 102.278V122.263C232.632 130.754 225.798 137.639 217.368 137.639C208.937 137.639 202.105 130.754 202.105 122.263V102.278",
    stroke: "#B6471F",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5781 109.139V180.389H128.42V109.139H31.5781Z",
    fill: "#299FC8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5273 109.139V180.389H128.422V109.139H60.5273Z",
    fill: "#299FC8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4727 116V192H130.525V116H29.4727Z",
    fill: "#C9E4F7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80 116V192H130.526V116H80Z",
    fill: "#8FD8F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M130.524 116L118.945 112.306V116H130.524Z",
    fill: "#C9E4F7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.945 112.223L128.419 109.139V115.473L118.945 112.223Z",
    fill: "#8FD8F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4727 116L41.0516 112.306V116H29.4727Z",
    fill: "#8FD8F3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0518 112.223L31.5781 109.139V115.473L41.0518 112.223Z",
    fill: "#C9E4F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4202 122.861V147.026C98.4202 157.29 90.173 165.611 79.9987 165.611C69.8236 165.611 61.5781 157.29 61.5781 147.026V122.861",
    stroke: "#2890B7",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.52093bcbc87edb17ef6ea6ab010dda4e.svg";
export { ForwardRef as ReactComponent };